import loadable from '@loadable/component'

const routes = [
  {
    path: '/tools/oss-text-fixer',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-oss-text-fixer" */ '~/pages/ossTextFixer'
        )
    ),
  },
  {
    path: '/',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-homepage" */ '~/pages/home')
    ),
  },
  {
    path: '/line/callback',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-line-callback" */ '~/pages/lineCallback'
        )
    ),
  },
  {
    path: '/apple/callback',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-apple-callback" */ '~/pages/appleCallback'
        )
    ),
  },
  {
    path: '/experienceActivity',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-experience-activity" */ '~/pages/experienceActivity'
        )
    ),
  },
  {
    path: '/download',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-download" */ '~/pages/download')
    ),
  },
  {
    path: '',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-notFound" */ '~/pages/notFound')
    ),
  },
]

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (store) => routes
